import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { obtenerMercaderiaRebajaAdicional } from '../../actions/listados'
import MercaderiaRebajaAdicionalView from '../../components/listados/MercaderiaRebajaAdicionalView'

function MercaderiaConRebajaAdicional (props) {
  const { obtenerMercaderiaRebajaAdicional } = props

  useEffect(() => {
    obtenerMercaderiaRebajaAdicional(new Date(), new Date())
  }, [obtenerMercaderiaRebajaAdicional])

  const actualizarFechas = (fechaD, fechaH) => {
    obtenerMercaderiaRebajaAdicional(fechaD, fechaH)
  }

  return (
    <>
      <div className='container-entre-fechas' style={{ margin: '-3% auto 0 auto' }}>
        <DatePicker
          selectRange
          disabledFuture
          locale='es'
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>
      <MercaderiaRebajaAdicionalView />
    </>
  )
}

const mapActionsToProps = {
  obtenerMercaderiaRebajaAdicional
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(MercaderiaConRebajaAdicional)
